import axios from "axios";
import React, { useEffect, useState } from "react";
import { Button, Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Templates from "../signTemplates/Templates";
import { useRef } from "react";
import { toast } from "react-toastify";
import routes from "../../../assets/lang/routes";
import { userTemplateDetails } from "../../../slice/template";
import {
  customTextColor,
  customThemeColor,
  customLinkColor,
  customFontSize,
  customFontFamily,
  customNameColor,
  resetStyle,
  imageSize,
  imageShape,
  iconSize,
  iconsThemeDefault,
} from "../../../slice/style";
import { imageUrl } from "../../../slice/images";
import {
  bannerImage,
  bannerurl,
  resetUploadBanner,
} from "../../../slice/Features/uploadBanner";
import {
  disclaimerText,
  disclaimerColor,
  disclaimerSize,
  resetDisclaimer,
} from "../../../slice/Features/disclaimer";
import {
  downloadAppText,
  downloadAppColor,
  downloadAppSize,
  resetDownloadApp,
} from "../../../slice/Features/downloadApps";
import {
  quoteText,
  quoteColor,
  quoteSize,
  resetquote,
} from "../../../slice/Features/quote";
import { HtmlFeature } from "../../../slice/Features/Html";
import {
  videoConferenceText,
  videoConferenceColor,
  videoConferenceSize,
  videoConferenceType,
  videoConferenceLink,
  resetvideoConference,
} from "../../../slice/Features/videoConference";

import lang from "../../../assets/lang/toastMsg.json";
import image from "../../../assets/lang/icons.json";
import style from "./Editor.module.css";
import PopUpModal from "../Modal/PopUpModal";
import BodyLoading from "../Loading/BodyLoading";

export default function Editor() {
  const userData = useSelector((state) => state.user);
  const userStyle = useSelector((state) => state.userStyle);
  const userTemplate = useSelector((state) => state.userTemplate);
  const userImages = useSelector((state) => state.userImages);
  const userFeatures = useSelector((state) => state.userFeatures);

  const [currentFeature, setCurrentFeature] = useState(
    userFeatures.currentFeature[0].currentFeature
  );
  const TempsRef = useRef();

  const Navigator = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [bodyloading, setBodyLoading] = useState(false);

  const [tempName, setTempName] = useState("temp1");

  const [checkStorage, setCheckStorage] = useState(
    localStorage.getItem("auth_token") ? true : false
  );
  const [getUserTempid, setGetUserTempid] = useState("");

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const saveMyTemplate = (e) => {
    e.preventDefault();

    setShow(false);

    if (!checkStorage) {
      return (
        <>
          {toast.info(`${lang.loginFirst}`, {
            closeOnClick: true,
            theme: "colored",
          })}
        </>
      );
    } else {
      if (userData.profileFormData[0].profileFormData) {
        var testEmail = /^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/i;
        var testMobile = /^[a-zA-z]/;

        if (
          userData.data[0].email !== "" &&
          !testEmail.test(userData.data[0].email)
        ) {
          toast.error(`${lang.emailValid}`, {
            closeOnClick: true,
            theme: "colored",
          });
        } else if (
          userData.data[0].mobile_number !== "" &&
          testMobile.test(userData.data[0].mobile_number)
        ) {
          toast.error(`${lang.mobileNumberValid}`, {
            closeOnClick: true,
            theme: "colored",
          });
        } else if (
          userImages.image[0].imageUrl === `${image.staticImage}` &&
          tempName !== "temp7"
        ) {
          toast.error(`${lang.imageRequired}`, {
            closeOnClick: true,
            theme: "colored",
          });
        } else {
          const data = {
            current_temp_id: getUserTempid,
            html: TempsRef.current.outerHTML,
            userTemplatename: userTemplate.userTemplateName[0].userTemplateName,
            templateName: tempName,
            firstName: userData.data[0].firstName,
            lastName: userData.data[0].lastName,
            title: userData.data[0].title,
            companyName: userData.data[0].companyName,
            department: userData.data[0].department,
            mobile_number: userData.data[0].mobile_number,
            website: userData.data[0].website,
            email: userData.data[0].email,
            address: userData.data[0].address,
            instagram: userData.data[0].instagram,
            facebook: userData.data[0].facebook,
            twitter: userData.data[0].twitter,
            linkedIn: userData.data[0].linkedIn,

            imageUrl:
              userImages.image[0].imageUrl === `${lang.staticImage} `
                ? ""
                : userImages.image[0].imageUrl,

            textColor: userStyle.customTextColor[0].textColor,
            textName: userStyle.customNameColor[0].textName,
            themeColor: userStyle.customThemeColor[0].themeColor,
            linkColor: userStyle.customLinkColor[0].linkColor,
            fontSize: userStyle.customFontSize[0].fontSize,
            fontFamily: userStyle.customFontFamily[0].fontFamily,

            themeIcons: userStyle.iconsThemeDefault[0].iconsThemeDefault,
            imageShape: userStyle.imageShape[0].imageShape,
            imageSize: userStyle.imageSize[0].imageSize,
            iconSize: userStyle.iconSize[0].iconSize,
          };

          async function createOrUpdateTemplate() {
            try {
              setBodyLoading(true);
              const response = await axios.post("/save-temp", data);
              setBodyLoading(false);
              if (response.data.status === 200) {
                dispatch(imageUrl(""));
                dispatch(userTemplateDetails(""));
                dispatch(resetStyle(true));
                dispatch(resetDisclaimer(true));
                dispatch(resetUploadBanner(true));
                dispatch(resetDownloadApp(true));
                dispatch(resetvideoConference(true));
                Navigator(routes.mySignature);

                toast.success(response.data.message, {
                  closeOnClick: true,
                  theme: "colored",
                });
              } else {
                console.log(response.data);
              }
            } catch (error) {
              console.log(error);
            }
          }
          createOrUpdateTemplate();
        }
      } else {
        toast.error(`${lang.FirstNameRequired}`, {
          closeOnClick: true,
          theme: "colored",
        });
      }
    }
  };

  const fetch = async () => {
    try {
      if (checkStorage) {
        setBodyLoading(true);
        setLoading(true);
        const response = await axios.get("/getUser");
        const user = await response.data.user;

        setBodyLoading(false);
        setLoading(false);

        if (user.current_temp_id !== null) {
          setGetUserTempid(user.current_temp_id);
          //template
          dispatch(userTemplateDetails(user.edit_template.user_template_name));
          dispatch(
            user.edit_template.user_template_name !== "temp7"
              ? imageUrl(user.image)
              : null
          );

          //style

          dispatch(customTextColor(user.edit_template.text_color));
          dispatch(customNameColor(user.edit_template.text_name));
          dispatch(customThemeColor(user.edit_template.theme_color));
          dispatch(customLinkColor(user.edit_template.link_color));
          dispatch(customFontSize(user.edit_template.font_size));
          dispatch(customFontFamily(user.edit_template.font_family));
          dispatch(
            iconsThemeDefault(
              user.edit_template.theme_icons === 0 ? false : true
            )
          );
          dispatch(imageShape(user.edit_template.image_shape));
          dispatch(imageSize(user.edit_template.image_size));
          dispatch(iconSize(user.edit_template.icon_size));
        }
        //features
        if (user.upload_banner_id !== null) {
          dispatch(bannerImage(user.upload_banner.image));
          dispatch(bannerurl(user.upload_banner.url));
        }
        if (user.disclaimer_id !== null) {
          dispatch(
            disclaimerText(
              user.disclaimer.text !== null ? user.disclaimer.text : ""
            )
          );
          dispatch(disclaimerColor(user.disclaimer.color));
          dispatch(disclaimerSize(user.disclaimer.size));
        }
        if (user.download_apps_id !== null) {
          const data = {
            Title:
              user.download_apps.title !== null ? user.download_apps.title : "",
            GooglePlay:
              user.download_apps.google_store_url !== null
                ? user.download_apps.google_store_url
                : "",
            AppStore:
              user.download_apps.app_store_url !== null
                ? user.download_apps.app_store_url
                : "",
          };
          dispatch(downloadAppText(data));
          dispatch(downloadAppColor(user.download_apps.color));
          dispatch(downloadAppSize(user.download_apps.size));
        }
        if (user.quote_id !== null) {
          dispatch(quoteText(user.quote.text !== null ? user.quote.text : ""));
          dispatch(quoteColor(user.quote.color));
          dispatch(quoteSize(user.quote.size));
        }
        if (user.html_id !== null) {
          dispatch(HtmlFeature(user.html.text));
        }
        if (user.video_conference_id !== null) {
          dispatch(videoConferenceText(user.video_conference.button_name));
          dispatch(videoConferenceColor(user.video_conference.color));
          dispatch(videoConferenceSize(user.video_conference.size));
          dispatch(videoConferenceType(user.video_conference.multiple_apps));
          dispatch(videoConferenceLink(user.video_conference.link));
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetch();
  }, [dispatch, checkStorage]);

  useEffect(() => {
    document.title = "Editor";

    setTempName(userTemplate.template[0].templateName);
    setCurrentFeature(userFeatures.currentFeature[0].currentFeature);

    function handleStorage() {
      setCheckStorage(localStorage.getItem("auth_token") ? true : false);
    }
    window.addEventListener("storage", handleStorage);
    return () => {
      window.removeEventListener("storage", handleStorage);
    };
  }, [
    checkStorage,
    userData,
    userStyle,
    userImages,
    userTemplate,
    userFeatures,
    currentFeature,
  ]);

  return (
    <div
      className={`bg-orange ${style.main}`}
      style={{
        minHeight: `${!checkStorage ? "93.6vh" : "88.5vh"}`,
      }}
    >
      {bodyloading ? <BodyLoading /> : null}
      <Container className="my-5">
        <div className="card border-0 shadow text-start w-75 m-auto">
          <div className="card-header p-0 text-white">
            <div
              className="bg-blue p-0"
              style={{ borderRadius: "5px 5px 0px 0px" }}
            >
              <div className="doots border-bottom border-secondary d-flex p-2">
                <div className={` ${style.dootsItem} bg-danger  `}></div>
                <div className={` ${style.dootsItem} bg-primary  `}></div>
                <div className={` ${style.dootsItem} bg-warning  `}></div>
              </div>

              <div className="px-4 py-3 fw-bold d-flex align-item-center">
                To: Your Recipient
                <br />
                Subject: Check out my new Email Signature
              </div>
            </div>

            <div
              className="w-100 shadow bg-white text-start  m-auto"
              style={{ borderRadius: "0px 0px 5px 5px" }}
            >
              <div className="card border-0 ">
                <div className="card-body ">
                  <div
                    className="wrapper d-flex justify-content-center align-items-center "
                    style={{ minHeight: "300px" }}
                  >
                    <div
                      style={{
                        background: "transparent",
                        fontFamily: userStyle.customFontFamily[0].fontFamily,
                      }}
                      ref={TempsRef}
                    >
                      {loading ? null : (
                        // <Spinner />
                        <Templates TemplateType={tempName} key={tempName} />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className=" d-flex justify-content-end w-75 m-auto my-4">
          {loading ? (
            ""
          ) : getUserTempid ? (
            <button
              className={`
              btn btn-lg btn-success 
            
              `}
              onClick={handleShow}
            >
              {/* ${!userData.profileFormData[0].profileFormData ? "disabled" : ""}  */}
              Done Updates
            </button>
          ) : (
            <Button onClick={saveMyTemplate} className="btn btn-lg btn-primary">
              Create Signature
            </Button>
          )}
          {show ? (
            <PopUpModal
              title={"Publish changes"}
              setmodalstate={setShow}
              showFooter={false}
            >
              <div className="d-flex align-items-center flex-column">
                Publishing changes will update your signature on integrated
                email clients
                <Button
                  variant="primary"
                  className="mt-4 w-100"
                  onClick={saveMyTemplate}
                >
                  Save Changes
                </Button>
                <Button
                  variant="outline-secondary "
                  className="mt-2 w-100"
                  onClick={handleClose}
                >
                  Close
                </Button>
              </div>
            </PopUpModal>
          ) : null}
        </div>
      </Container>
    </div>
  );
}
